import { createEvent } from "library/local-events/index.mjs"

// Plugins push extra columns for the regime table: { field, label, width, cell }. The cell element is
// rendered in each row, where the row's regime is bound as parentItem.
export const RegimeTableColumns = createEvent("RegimeTableColumns")
